<nz-select
    nzSize="small"
    [(ngModel)]="selectedChain"
    (ngModelChange)="selectedChainChange.emit($event)"
    [nzCustomTemplate]="customTemplateTpl"
    class="w-[110px]"
>
    <nz-option *ngIf="enableAll" nzLabel="All" nzValue="all" nzCustomContent>
        <div class="flex-start-center gap-x-2 text-sm font-normal">
            <nz-avatar-group>
                <nz-avatar style="width: 18px; height: 18px; line-height: 18px" [nzSrc]="getChainImg(ChainEnum.BASE)"></nz-avatar>
                <nz-avatar style="width: 18px; height: 18px; line-height: 18px" [nzSrc]="getChainImg(ChainEnum.BSC)"></nz-avatar>
            </nz-avatar-group>
            <span>All</span>
        </div>
    </nz-option>

    <nz-option *ngFor="let option of options" [nzValue]="option.value" [nzLabel]="option.label" nzCustomContent>
        <div class="flex-start-center gap-x-2 text-sm font-normal">
            <img [src]="getChainImg(option.value)" class="w-[18px] h-[18px] rounded-full" />
            <span>{{ option.label }}</span>
        </div>
    </nz-option>

    <ng-template #customTemplateTpl let-selected>
        <div *ngIf="selected.nzValue === 'all'" class="flex-start-center gap-x-2">
            <nz-avatar-group>
                <nz-avatar style="width: 18px; height: 18px; line-height: 18px" [nzSrc]="getChainImg('sol')"></nz-avatar>
                <nz-avatar style="width: 18px; height: 18px; line-height: 18px" [nzSrc]="getChainImg(ChainEnum.BASE)"></nz-avatar>
                <nz-avatar style="width: 18px; height: 18px; line-height: 18px" [nzSrc]="getChainImg(ChainEnum.BSC)"></nz-avatar>
            </nz-avatar-group>
            <span>All</span>
        </div>

        <div *ngIf="selected.nzValue !== 'all'" class="flex-start-center gap-x-2">
            <img [src]="getChainImg(selected.nzValue)" class="w-[18px] h-[18px] rounded-full" />
            <span>{{ selected.nzLabel }}</span>
        </div>
    </ng-template>
</nz-select>
